<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton @click.native="openDialog" textColor="#a63232">
        <inline-svg :src="require('@/assets/svg/thumb_down.svg')" width="25" />
        Reject Offer
      </SecondaryButton>
      <RejectOfferDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import RejectOfferDialog from "@/views/offers/dialogs/RejectOfferDialog";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "RejectOfferAction",
  components: {
    SecondaryButton,
    RejectOfferDialog,
    BaseAction,
    InlineSvg
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
